import { ClassAttributes, createElement, useContext, FC } from 'react';
import Component from '../component/compound/HeadBar';
import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';
import { context as ConfigContext } from '../context/config';

type Props = ClassAttributes<HTMLElement>;

const HeadBar: FC<Props> = () => {
  const dependency = useContext(DependencyContext);
  const config = useContext(ConfigContext);
  const state = useContext(StateContext);

  return !state.fatalError && state.authentication.fetching === 0 && state.authentication.signedInUser ? (
    <Component
      signedInUser={state.authentication.signedInUser}
      onClickAccountSettings={() => {
        const url = `${config.ID_WEB_URL}`;
        const win = window.open(url, '_blank');
        if (win !== null) {
          win.focus();
        }
      }}
      onClickSignOut={() => dependency.authenticationUsecase.signOut()}
    />
  ) : null;
};

export default HeadBar;
